<template>
    <fragment>
        <out-put-page
            :noPadding="true"
            :fullHeight="true"
            v-for="(picture, index) in etudeMarcherUrls.evolutionMarche"
            :key="`${index + picture.fileName}`"
        >
            <template v-slot:noPadding>
                <img
                    class="etude-marche-img"
                    :src="picture.url"
                    alt="Taille et évolution du marché"
                />
            </template>
        </out-put-page>
        <out-put-page
            :noPadding="true"
            :fullHeight="true"
            v-for="(picture, index) in etudeMarcherUrls.santeFinanciere"
            :key="`${index + picture.fileName}`"
        >
            <template v-slot:noPadding>
                <img
                    class="etude-marche-img"
                    :src="picture.url"
                    alt="Taille et évolution du marché"
                />
            </template>
        </out-put-page>
        <out-put-page
            :noPadding="true"
            :fullHeight="true"
            v-for="(picture, index) in etudeMarcherUrls.acteurPartMarcher"
            :key="`${index + picture.fileName}`"
        >
            <template v-slot:noPadding>
                <img
                    class="etude-marche-img"
                    :src="picture.url"
                    alt="Taille et évolution du marché"
                />
            </template>
        </out-put-page>
        <out-put-page
            :noPadding="true"
            :fullHeight="true"
            v-for="(picture, index) in etudeMarcherUrls.analyseConcurenciel"
            :key="`${index + picture.fileName}`"
        >
            <template v-slot:noPadding>
                <img
                    class="etude-marche-img"
                    :src="picture.url"
                    alt="Taille et évolution du marché"
                />
            </template>
        </out-put-page>
        <out-put-page
            :noPadding="true"
            :fullHeight="true"
            v-for="(picture,
            index) in etudeMarcherUrls.GeographicalDistribution"
            :key="`${index + picture.fileName}`"
        >
            <template v-slot:noPadding>
                <img
                    class="etude-marche-img"
                    :src="picture.url"
                    alt="Taille et évolution du marché"
                />
            </template>
        </out-put-page>
    </fragment>
</template>

<script>
// import { storage } from "@/services/firebase.service";
import OutPutPage from "../components/OutPutPage";

export default {
    components: {
        OutPutPage
    },
    props: {
        // activityID: {
        //     type: String,
        //     required: true
        // },
        etudeMarcherUrls: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            // etudeMarcherUrls: {}
        };
    }
};
</script>

<style></style>
